import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AlertCircleIcon, MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: 'Inicio',
  href: '/',
  external: false
}, {
  label: 'Agentes',
  href: '/agentes',
  external: false
}, {
  label: 'Dueños de Agencia',
  href: '/duenos-de-agencia',
  external: false
}, {
  label: 'Cómo Funciona',
  href: '/como-funciona',
  external: false
}, {
  label: 'Resultados',
  href: '/resultados',
  external: false
}, {
  label: 'Auditoría',
  href: '/auditoria',
  external: false
}, {
  label: 'Contacto',
  href: '/contact-us',
  external: false
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-charcoal/95 backdrop-blur-md border-b border-border-subtle shadow-lg shadow-black/30' : 'bg-charcoal/80 backdrop-blur-sm border-b border-border-subtle/50'}`} data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <div className="flex items-center justify-between py-1" data-id="element-120">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-121">
            <img src="https://cdn.magicpatterns.com/uploads/j5oSMX1HPmmh812g8Nqn8c/reclutas_digitales_logo_dorado.png" alt="Reclutas Digitales" className="h-20 w-auto object-contain" data-id="element-122" />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-1" data-id="element-123">
            {navLinks.map(link => link.external ? <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer" className="px-3 py-2 text-sm text-[#b8b4ae] hover:text-cream transition-colors rounded-md hover:bg-surface" data-id="element-124">
                  {link.label}
                </a> : <NavLink key={link.label} to={link.href} className={({
            isActive
          }) => `px-3 py-2 text-sm transition-colors rounded-md ${isActive ? 'text-accent font-medium' : 'text-[#b8b4ae] hover:text-cream hover:bg-surface'}`} data-id="element-125">
                  {link.label}
                </NavLink>)}
          </div>

          {/* CTA + Mobile Toggle */}
          <div className="flex items-center gap-3" data-id="element-126">
            <a href="/contact-us" className="hidden sm:inline-flex items-center px-4 py-2 bg-accent hover:bg-accent-hover text-charcoal font-semibold text-sm rounded-lg transition-colors duration-200" data-id="element-127">
              Agendar diagnóstico
            </a>
            <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 text-[#b8b4ae] hover:text-cream transition-colors" aria-label="Toggle menu" data-id="element-128">
              {isOpen ? <XIcon size={20} data-id="element-129" /> : <MenuIcon size={20} data-id="element-130" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Drawer */}
      <AnimatePresence data-id="element-131">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeInOut'
      }} className="lg:hidden overflow-hidden border-t border-border-subtle bg-charcoal/98 backdrop-blur-md" data-id="element-132">
            <div className="px-4 py-4 space-y-1" data-id="element-133">
              {navLinks.map(link => link.external ? <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer" className="block px-3 py-2.5 text-sm text-[#b8b4ae] hover:text-cream hover:bg-surface rounded-md transition-colors" data-id="element-134">
                    {link.label}
                  </a> : <NavLink key={link.label} to={link.href} className={({
            isActive
          }) => `block px-3 py-2.5 text-sm rounded-md transition-colors ${isActive ? 'text-accent font-medium bg-surface' : 'text-[#b8b4ae] hover:text-cream hover:bg-surface'}`} data-id="element-135">
                    {link.label}
                  </NavLink>)}
              <div className="pt-3 pb-1" data-id="element-136">
                <a href="/contact-us" className="block w-full text-center px-4 py-2.5 bg-accent hover:bg-accent-hover text-charcoal font-semibold text-sm rounded-lg transition-colors" data-id="element-137">
                  Agendar diagnóstico
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}